import { IconNameAndCategoryString } from '../../Icon'
import { TextArea } from '../../common/fields/TextArea'
import { NpsStep } from './NPSStepBasePage'
import {
    FieldIds,
    MAX_FEEDBACK_LENGTH,
    NPSFieldId,
    NPSStepId,
    NPSStepProps,
    StepIds,
} from './types'
import { NPSRecordState } from './NPSViewModel'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'
import { validateFeedback } from './validation'

const ADDITIONAL_FEEDBACK_FIELDS: {
    id: NPSFieldId
    placeholder: string
    icon: IconNameAndCategoryString
}[] = [
    {
        id: FieldIds.MOST_USEFUL_FEATURES,
        placeholder: 'Describe most useful features',
        icon: 'faceSmile.large',
    },
    {
        id: FieldIds.LEAST_USEFUL_FEATURES,
        placeholder: 'Describe least useful features',
        icon: 'faceFrown.large',
    },
    {
        id: FieldIds.IMPROVEMENT_AREAS,
        placeholder: 'Enter your thoughts',
        icon: 'pocketsuite.large',
    },
    {
        id: FieldIds.FINAL_THOUGHTS,
        placeholder: 'Enter your thoughts',
        icon: 'message.large',
    },
]

export const ADDITIONAL_FEEDBACK_STEP = {
    id: StepIds.ADDITIONAL_FEEDBACK,
    valuesOnNext: {
        // This is the last step with actual input. Mark the completed field as done on next.
        [FieldIds.CONFIRM_COMPLETE]: true,
    },
    validate: ({ getFieldValue }: NPSRecordState) => {
        return ADDITIONAL_FEEDBACK_FIELDS.every(({ id }) => validateFeedback(getFieldValue(id)))
    },
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NPSStepAdditionalFeedbackPage(props: NPSStepProps) {
    return (
        <NpsStep
            {...props}
            title="Last step"
            subtitle="Answer the following questions"
            fieldGroups={[
                ADDITIONAL_FEEDBACK_FIELDS.map(({ id, icon, placeholder }) => ({
                    id,
                    icon,
                    statusLine: (value: unknown) =>
                        `${(typeof value === 'string' ? value : '').length} / ${MAX_FEEDBACK_LENGTH}`,
                    render: (value: unknown, onChange: (value: unknown) => void) => (
                        <TextArea
                            isAutoResizing
                            value={typeof value === 'string' ? value : undefined}
                            placeholder={placeholder}
                            onChange={(e) => onChange(e.target.value)}
                            maxLength={MAX_FEEDBACK_LENGTH}
                        />
                    ),
                })),
            ]}
        />
    )
}
